module.exports = __webpack_public_path__ + "img/crops_tab.3f2ef460.png";